import React from "react";
import { createContext, useContext } from "./use-context-selector.js";
const SomeEditorPropsContext = createContext({});
const SomeEditorPropsContextProvider = ({
  children,
  visitorUploads,
  fileUploadSizeLimit,
  biSettings,
  pickMedia,
  generalLinkSettings
}) => {
  return /* @__PURE__ */ React.createElement(
    SomeEditorPropsContext.Provider,
    {
      value: React.useMemo(
        () => ({ visitorUploads, fileUploadSizeLimit, biSettings, pickMedia, generalLinkSettings }),
        [visitorUploads, fileUploadSizeLimit, biSettings, pickMedia, generalLinkSettings]
      )
    },
    children
  );
};
const useEditorProps = () => {
  const context = useContext(SomeEditorPropsContext);
  if (!context) {
    throw new Error("useEditorProps must be used within a SomeEditorPropsContextProvider");
  }
  return context;
};
export {
  SomeEditorPropsContext,
  SomeEditorPropsContextProvider,
  useEditorProps
};
//# sourceMappingURL=some-editor-props-context.js.map
